<template>
  <div class="min-h-screen p-6 space-y-4 animate-fade-in">
    <div class="skeleton h-8 w-48 rounded-md"></div>
    <div class="grid grid-cols-1 sm:grid-cols-4 gap-3">
      <div v-for="i in 4" :key="i" class="skeleton h-24 rounded-xl" :style="{ animationDelay: `${i * 60}ms` }" />
    </div>
    <div class="skeleton h-72 rounded-xl"></div>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div v-for="i in 3" :key="i" class="skeleton h-44 rounded-xl" :style="{ animationDelay: `${i * 80 + 200}ms` }" />
    </div>
  </div>
</template>
